// Basic web fallback for secureStore
export async function save(key: string, value: string) {
  localStorage.setItem(key, value);
}

export async function getValueFor(key: string) {
  return localStorage.getItem(key);
}

export async function deleteItem(key: string) {
  localStorage.removeItem(key);
}

export const getItemAsync = getValueFor;
export const setItemAsync = save;
export const deleteItemAsync = deleteItem; 